// LICENSE_CODE ZON
'use strict'; /*jslint node:true, react:true*/
let define;
let is_node = typeof module=='object' && module.exports;
if (is_node)
    define = require('../../../../util/require_node.js').define(module, '..');
else
    define = self.define;
define(['react', 'lodash4', '/util/string.js', '/www/lum/pub/util/general.js',
    '/www/lum/pub/comp/btn_icon.js', '/www/locale/pub/i18n_react.js',
    '/www/lum/pub/comp/tooltip.js',
    // import only
    'css!/www/lum/pub/css/title'],
    (React, _, string, general_util, {Btn_icon}, i18n, {Overflow_tooltip})=>
{
const {qw} = string;
const {T} = i18n;
const E = {};
const {assign} = Object;

const Title = ({text, classes, children, icon, overflow_tooltip,
    tag, height, id, icon_left=false, icon_size='xl', root_mark, ...rest})=>{
    let opts = qw`light sub mini small regular medium big error warning bold
    paragraph processing processing_icon no_weight info success tiny average`;
    let classname = general_util.get_classname('cp_title', classes, opts, rest)
        +(icon ? ' cp_title-with_icon' : '')
        +(icon_left ? ' cp_title--icon-left' : '')
        +(root_mark ? ' root_mark' : '');
    let content = children || text;
    if (_.isString(content))
        content = <T>{content}</T>;
    if (overflow_tooltip)
    {
        content = <Overflow_tooltip max_height={height}>
            {content}
          </Overflow_tooltip>;
    }
    let Tag = tag || 'div';
    let style = {};
    const icon_comp = <Btn_icon className="cp_title_icon"
      icon={icon}
      {...{[icon_size]: icon_size}}
    />;
    if (height)
        assign(style, {minHeight: height, maxHeight: height});
    return <Tag id={id} className={classname} style={style}
      {..._.omit(rest, opts)}>
      {icon && icon_left && icon_comp}
      {content}
      {icon && !icon_left && icon_comp}
    </Tag>;
};
E.Title = Title;

return E; }); // eslint-disable-line
